import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'gatsby'
import Layout from '../components/layout'
import Contact from '../components/contact'
import { Container, Row, Col } from 'react-bootstrap'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faClock } from '@fortawesome/free-solid-svg-icons'
import SEOIMG from '../img/seo.gif'
import SEA from '../img/sea.gif'
import CRO from '../img/cro.gif'
import DESIGN from '../img/design.gif'
import DEV from '../img/dev.gif'
import { CSSTransition } from 'react-transition-group'
import ColoredBanner from '../components/ColoredBanner'

config.autoAddCss = false

const ArticleTemplate = ({ pageContext, location }) => {
  const toc = useRef(null)
  const mainContent = useRef(null)

  const [showFixedTOC, setShowFixedTOC] = useState(false)

  function handleScroll() {
    const tocPosition = toc.current.getBoundingClientRect()
    const mainContentPosition = mainContent.current.getBoundingClientRect()

    if (tocPosition.y < -tocPosition.height && mainContentPosition.y > -mainContentPosition.height)
      setShowFixedTOC(true)
    else setShowFixedTOC(false)
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  if (!pageContext) return null

  return (
    <Layout location={location} title={pageContext.title} description={pageContext.metaDesc} lang="de" noEnglish={true}>

      <CSSTransition classNames="fade-in-out" timeout={300}>
        {showFixedTOC ? (
          <ul id="fixed-toc" className="bg-green">
            {pageContext.headings.map((headline, index) => (
              <li key={headline.id}>
                <Link to={`${pageContext.slug}#${headline.id}`}>
                  {index}. {headline.value}
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <></>
        )}
      </CSSTransition>

      <Container>
        <ColoredBanner
          backgroundColor="green"
          title={pageContext.title}
          subHeadline={
            <span className="small text-muted w-100">
              <FontAwesomeIcon icon={faCalendar} />
              &nbsp;{pageContext.date}&nbsp;&nbsp;
              <FontAwesomeIcon icon={faClock} />
              &nbsp;Lesezeit ca. {pageContext.timeToRead}&nbsp;Minuten
            </span>
          }
        >
          <p className="mt-2">{pageContext.intro}</p>
          <ul id="toc" ref={toc}>
            {pageContext.headings.map(headline => (
              <li key={headline.id}>
                <Link to={`${pageContext.slug}#${headline.id}`}>{headline.value}</Link>
              </li>
            ))}
          </ul>
        </ColoredBanner>

        <Row>
          <Col xs={11} md={10} id="main-content" className="mx-auto" ref={mainContent}>
            <div dangerouslySetInnerHTML={{ __html: pageContext.html }} />
          </Col>
        </Row>

        <Row className="mt-5">
          <Col xs={11} md={10} className="mx-auto text-center">
            <div className="big-fat-red mb-5">Über uns.</div>
            <p className="pb-3">
              Statt Dienstleistungen an der Oberfläche bieten wir Ihnen vom ersten Moment an maßgeschneiderte Lösungen
              für Ihre Anforderungen. ganztags. ist nah an Ihren Themen und identifiziert sich damit wie einer Ihrer
              Mitarbeiter. Unsere Kunden durchlaufen keine Ebenen von Projekt- und Produktmanagern. Unser Team spricht
              direkt 1-zu-1 mit dem Kunden. Somit halten wir nicht nur den Wasserkopf, sondern auch das Budget auf einem
              nötigen Niveau.
            </p>
            <hr className="p-3" />
          </Col>
        </Row>

        <Row>
          <Col xs={11} md={10} className="mx-auto py-2">
            <p className="text-center">
              Wie wir die Wünsche unserer Kunden erfüllen, erklärt
              <a href="/leistungen/" className="semi-bold d-block">
                unsere Arbeitsweise.
              </a>
            </p>
          </Col>
        </Row>

        <Row>
          <a href="/leistungen/#seo" className="col-6 col-md my-3 text-center h-355">
            <img src={SEOIMG} height="120" className="mt-5 mb-4 d-block" alt="Suchmaschinenoptimierung" />
            <strong>SEO</strong>
            <div className="my-3">Optimierung für Suchmaschinen</div>
            <div className="shadow-block"></div>
          </a>
          <a href="/leistungen/#sea" className="col-6 col-md my-3 text-center h-355">
            <img src={SEA} height="120" className="mt-5 mb-4 d-block" alt="Suchmaschinenoptimierung" />
            <strong>SEA</strong>
            <div className="my-3">
              Werbung in <br />
              Suchmaschinen
            </div>
            <div className="shadow-block"></div>
          </a>
          <a href="/leistungen/#cro" className="col-6 col-md my-3 text-center h-355">
            <img src={CRO} height="120" className="mt-5 mb-4 d-block" alt="Conversion Rate Optimierung" />
            <strong>CRO</strong>
            <div className="my-3">
              Conversion Rate <br />
              Optimierung
            </div>
            <div className="shadow-block"></div>
          </a>
          <a href="/leistungen/#design" className="col-6 col-md my-3 text-center h-355">
            <img src={DESIGN} height="120" className="mt-5 mb-4 d-block" alt="Design" />
            <strong>Design</strong>
            <div className="my-3">
              UI/UX und <br />
              Corporate Design
            </div>
            <div className="shadow-block"></div>
          </a>
          <a href="/leistungen/#dev" className="col-12 col-md mt-3 text-center h-355">
            <img src={DEV} height="120" className="mt-5 mb-4 d-block" alt="Technische Entwicklung" />
            <strong>DEV</strong>
            <div className="mt-3">Webentwicklung</div>
            <div className="shadow-block"></div>
          </a>
        </Row>
      </Container>
      <Contact />
    </Layout>
  )
}
export default ArticleTemplate

// export const query = graphql`
//   query ArticleTemplate($id: String!) {
//     markdownRemark(id: { eq: $id }) {
//       id
//       html
//       frontmatter {
//         title
//         date(locale: "de", formatString: "MMMM Y")
//         intro
//         metaDesc
//       }
//       timeToRead
//       headings(depth: h2) {
//         value
//         id
//       }
//     }
//   }
// `
